import React from "react";

export const SummaryCards = ({ rows }) => {
  const count = (fn) => rows.filter(fn).length;
  const items = [
    { label: "Formulaires", value: count((r) => r.type === "form"), testid: "summary-forms" },
    { label: "Clics appel", value: count((r) => r.type === "call"), testid: "summary-calls" },
    { label: "Validés", value: count((r) => r.status === "validated"), testid: "summary-validated", accent: "text-green-700" },
    { label: "Pas qualifiés", value: count((r) => r.status === "unqualified"), testid: "summary-unqualified", accent: "text-red-600" },
    { label: "En attente", value: count((r) => !r.status), testid: "summary-pending", accent: "text-amber-600" },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
      {items.map((i) => (
        <div key={i.label} className="bg-white border border-slate-200 rounded-xl p-4" data-testid={i.testid}>
          <p className="text-xs text-slate-500">{i.label}</p>
          <p className={`text-2xl font-bold mt-1 ${i.accent || "text-slate-900"}`}>{i.value}</p>
        </div>
      ))}
    </div>
  );
};
